// extracted by mini-css-extract-plugin
export default {"item":"Item_item__9ibr7","anchor":"Item_anchor__KOMC6","title":"Item_title__wXXpG"};